import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import { provideHttpClient, HttpClient } from '@angular/common/http';

import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationLoaderFactory } from './translation.loader';

import { firstValueFrom } from 'rxjs';

function initI18n(translate: TranslateService) {
  return async () => {
    const lang = 'de';

    translate.setDefaultLang('de');
    translate.use(lang);

    await firstValueFrom(translate.getTranslation(lang));
  };
}

export const appConfig: ApplicationConfig = {
  providers: [

    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      return initI18n(translate)();
    }),

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    provideHttpClient(),

    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'de',
        loader: {
          provide: TranslateLoader,
          useFactory: TranslationLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ]
};
